import React, { Fragment, ReactNode, useEffect, useRef, useState } from "react";
import { ISofProps } from "./SofPage";
import { FontIcon } from "@fluentui/react";
import ApiSpinner from "../common/ApiSpinner";
import "./StatusBar.css";
import clsx from "clsx";
import { ProcessFlowState } from "../../models/ProcessFlowConfig";

interface IProps extends ISofProps {
  className: string;
}

const StatusBar: React.FC<IProps> = (props: IProps) => {
  const {
    className,
    lineHandling,
    config,
    selectedState,
    nomination,
    activityLogs,
  } = props;
  const [status, setStatus] = useState("");
  const [scope, setScope] = useState("");
  const [percentage, setPercentage] = useState(0);
  //const [processStates, setProcessStates] = useState<ProcessState[]>([]);
  const [isLineHandling, setIsLineHandling] = useState(false);
  const [states, setStates] = useState<ProcessFlowState[]>([]);
  const targetSpan = useRef<HTMLSpanElement>(null);
  let hasActiveYet = false;

  useEffect(() => {
    let _state = "";
    if (nomination) {
      _state = nomination.currentState;
      setStatus(nomination.currentState);
      setScope(nomination.transferType.replace(" ", ""));
      setPercentage(nomination.progress);
      setIsLineHandling(false);
    } else {
      setScope("LineHandling");
      if (lineHandling.result) {
        _state = lineHandling.result.currentState;
        setStatus(lineHandling.result.currentState);
        setPercentage(lineHandling.result.progress);
        setIsLineHandling(true);
      }
    }

    if (config && config.states) {
      const s = config.states.filter(
        (f) => _state === "..." || f.name !== "..."
      );
      setStates(s);
    }
  }, [nomination, lineHandling, activityLogs, config]);

  return (
    // <div className={clsx("line-status", className)}>
    //  {config.isLoading && <ApiSpinner />}
    <div className="btn-menu-status">
      {states.map((state, index) => {
        const isSelected = selectedState === state.name;
        const isActive = status === state.name;
        const width = isActive ? `${percentage}%` : hasActiveYet ? "0" : "100%";

        const div = (
          <div className="btn-menu-wrapper">
            <div
              className={clsx(
                "btn-status",
                isSelected ? "selected" : "",
                isActive ? "active" : "",
                hasActiveYet ? "disabled" : ""
              )}
              style={{ cursor: "pointer" }}
              onClick={
                isActive || !hasActiveYet
                  ? () => props.setSelectedState(state.name)
                  : undefined
              }
            >
              <div className="d-flex">
                <div
                    style={{
                        marginRight: "auto",
                        height: "24px",
                        fontSize: "16px",
                        overflow: "hidden",
                    }}
                >
                  {state.name}
                </div>
                <div>
                            {isActive ? (
                                <span style={{ color: "#000", fontSize: 18 }}>
                                    {percentage.toFixed(0)}%
                                </span>
                  ) : (
                    !hasActiveYet && (
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M2.08332 8C2.08332 6.68823 2.49606 5.40972 3.26306 4.34556C4.03006 3.2814 5.11245 2.48555 6.3569 2.07073C7.60135 1.65591 8.94477 1.64316 10.1969 2.03429C11.449 2.42542 12.5463 3.20059 13.3333 4.25H10.2083C10.0426 4.25 9.88359 4.31585 9.76638 4.43306C9.64917 4.55027 9.58332 4.70924 9.58332 4.875C9.58332 5.04076 9.64917 5.19973 9.76638 5.31694C9.88359 5.43415 10.0426 5.5 10.2083 5.5H13.9583C14.1241 5.5 14.2831 5.43415 14.4003 5.31694C14.5175 5.19973 14.5833 5.04076 14.5833 4.875V1.125C14.5833 0.95924 14.5175 0.800269 14.4003 0.683058C14.2831 0.565848 14.1241 0.5 13.9583 0.5C13.7926 0.5 13.6336 0.565848 13.5164 0.683058C13.3992 0.800269 13.3333 0.95924 13.3333 1.125V2.41C12.0534 1.26516 10.4193 0.594243 8.70412 0.509342C6.98897 0.424441 5.29662 0.9307 3.90985 1.94353C2.52308 2.95636 1.52588 4.41442 1.08486 6.07408C0.643853 7.73375 0.785743 9.49448 1.48683 11.0621C2.18791 12.6297 3.40573 13.9093 4.93679 14.687C6.46785 15.4647 8.21943 15.6934 9.89886 15.335C11.5783 14.9765 13.0838 14.0526 14.164 12.7175C15.2441 11.3825 15.8334 9.71726 15.8333 8C15.8333 7.83424 15.7675 7.67527 15.6503 7.55806C15.5331 7.44085 15.3741 7.375 15.2083 7.375C15.0426 7.375 14.8836 7.44085 14.7664 7.55806C14.6492 7.67527 14.5833 7.83424 14.5833 8C14.5833 9.6576 13.9248 11.2473 12.7527 12.4194C11.5806 13.5915 9.99093 14.25 8.33332 14.25C6.67572 14.25 5.08601 13.5915 3.91391 12.4194C2.74181 11.2473 2.08332 9.6576 2.08332 8Z"
                          fill="#1890FF"
                        />
                      </svg>
                    )
                  )}
                </div>
              </div>
            </div>
            <div
              style={{ height: "4px", background: "#E2E6E8", width: "100%" }}
            >
              <div
                style={{ height: "4px", background: "#1890FF", width: width }}
              ></div>
            </div>
          </div>
        );

        // const div = (
        //   <Fragment key={`state-${state.id}`}>
        //     <div
        //       id={`btn-state-${state.name}`}
        //       className={clsx(
        //         "line-status-item",
        //         isSelected ? "selected" : "",
        //         isActive ? "active" : ""
        //       )}
        //       onClick={
        //         isActive || !hasActiveYet
        //           ? () => props.setSelectedState(state.name)
        //           : undefined
        //       }
        //     >
        //       <div>
        //         <div>
        //           {isActive ? (
        //             <span style={{ color: "#fff", lineHeight: "30px" }}>
        //               {percentage.toFixed(0)}%
        //             </span>
        //           ) : (
        //             !hasActiveYet && <FontIcon iconName="CheckMark" />
        //           )}
        //         </div>
        //       </div>
        //       <span
        //         className="list-status-item-text"
        //         ref={isActive ? targetSpan : undefined}
        //       >
        //         {state.name}
        //       </span>
        //     </div>

        //     {index + 1 !== states.length ? (
        //       <span className="step-connector">
        //         <span
        //           className={clsx("connector-line", isActive ? "active" : "")}
        //           style={{
        //             width,
        //           }}
        //         ></span>
        //       </span>
        //     ) : (
        //       <React.Fragment />
        //     )}
        //   </Fragment>
        // );

        if (!hasActiveYet) {
          hasActiveYet = isActive;
        }
        return div;
      })}
    </div>
    //</div>
  );
};

export default StatusBar;
